import Badge from "@/tpo/Badge";

export default function ConnectedBadge({ text = "connected", mr = 0 }) {
  return (
    <Badge bg="green" color="white" size="xs" mr={mr}>
      {text}
    </Badge>
  );
}
